import React from 'react';

const NewIncentiveContainer = () => {
  return <div>NewIncentiveContainer</div>;
};

export default NewIncentiveContainer;
